import React, { FC } from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import round from "lodash/round";

import { SubscriptionCardProps } from "../../../../components/SubscriptionCard/types";
import { getMonthsInterval } from "../../../../components/SubscriptionCard/utils";
import { getInterval } from "../../../../utils/common";
import Button from "../../../../components/Button";
import Icon from "../../../../components/Icon";
import { IconName } from "../../../../components/Icon/types";
import Price from "../../../../components/Price";

import "./styles.scss";

export const SubscriptionCard: FC<SubscriptionCardProps> = ({
  data,
  onSelect,
  selected,
  selectedLabel,
  features,
}) => {
  const { t } = useTranslation();

  const monthsInterval = data.sp.billing_period
    ? getMonthsInterval(data.sp.billing_period)
    : 0;
  const pricePerInterval = round(
    data?.geoCost?.amount / (monthsInterval || 1),
    2,
  );
  const isCorporate = (data?.licenses || 1) > 1;
  const interval =
    data.sp.billing_period && getInterval(data.sp.billing_period);

  const handleSelectPlanClick = () => {
    onSelect(data);
  };

  const selectPlanButton = () => {
    return (
      <Button
        className="ams-subscription-card__select-btn"
        onClick={handleSelectPlanClick}
      >
        {t("selectPlan")}
      </Button>
    );
  };

  return (
    <div
      className={classnames("ams-subscription-card", {
        "ams-subscription-card--selected": selected,
      })}
    >
      <header className="ams-subscription-card__header">
        <h2 className="ams-subscription-card__title">
          <span className="ams-subscription-card__title-text">
            {data.sp.name}
          </span>
        </h2>
        {selected ? (
          <div className="ams-subscription-card__selected-label">
            <Icon>{"checkmark" as IconName}</Icon>
            {selectedLabel}
          </div>
        ) : (
          selectPlanButton()
        )}
      </header>
      <div className="ams-subscription-card__content">
        <section className="ams-subscription-card__price-tag">
          {isCorporate ? (
            <>
              <Price
                currencyCode={data.geoCost?.currency}
                amount={data.geoCost?.amount}
              />
              <span className="ams-subscription-card__price-tag-unit">
                {t("perYear")}
              </span>
              <span className="ams-subscription-card__licenses">
                &nbsp;
                {t("forLicenses", { licenses: data.licenses })}
              </span>
            </>
          ) : (
            <>
              <Price
                currencyCode={data.geoCost?.currency}
                amount={pricePerInterval}
              />
              <span className="ams-subscription-card__price-tag-unit">
                {t("perMonth")}
              </span>
            </>
          )}
        </section>
        <section>
          {/* Not implemented yet */}
          {/* {data.oldTotal && (
            <span className="ams-subscription-card__old-price">
              {data.oldTotal}
            </span>
          )} */}
          {isCorporate && data.currentAddon ? (
            <>
              <Price
                currencyCode={data.currentAddon?.geoCost?.currency}
                amount={data.currentAddon?.geoCost?.amount}
              />
              {t("perAdditionalLicense")}
            </>
          ) : (
            <>
              <span className="ams-subscription-card__new-price">
                &nbsp;
                <Price
                  currencyCode={data.geoCost?.currency}
                  amount={data?.geoCost?.amount}
                />
                &nbsp;
              </span>
              {interval && (
                <span>
                  {t("billedEvery", {
                    intervalLength: interval.length,
                    intervalUnit: t(interval.unit, {
                      [interval.unit]: interval.length,
                    }),
                  })}
                </span>
              )}
            </>
          )}
        </section>
        {features && (
          <section className="ams-subscription-card__features">
            <ul className="ams-subscription-card__features-list">
              {features.map((feature, idx) => {
                return (
                  <li key={idx} className="ams-subscription-card__feature">
                    {t(feature)}
                  </li>
                );
              })}
            </ul>
          </section>
        )}
      </div>
    </div>
  );
};
